import * as m from "motion/react-m";
import clsx from "clsx";

interface InteractionHintProps {
  isVisible: boolean;
  reduceMotion: boolean;
  className?: string;
}

const STROKES = [
  { d: "M20 6C23 18 21 35 20 48", transition: { duration: 0.6, ease: "easeInOut", delay: 0.3 } },
  { d: "M12 40L20 48L28 40", transition: { duration: 0.32, ease: "easeOut", delay: 0.85 } },
] as const;

export function InteractionHint({ isVisible, reduceMotion, className }: InteractionHintProps) {
  const shown = isVisible || reduceMotion;
  return (
    <div aria-hidden className={clsx("tw-pointer-events-none tw-flex tw-justify-center", className)}>
      <svg viewBox='0 0 40 56' fill='none' aria-hidden className='tw-h-14 tw-w-10 tw-text-white tw-drop-shadow'>
        {STROKES.map(({ d, transition }) => (
          <m.path
            key={d}
            d={d}
            stroke='currentColor'
            strokeWidth='2.5'
            strokeLinecap='butt'
            strokeLinejoin='round'
            initial={reduceMotion ? false : { pathLength: 0 }}
            animate={{ pathLength: shown ? 1 : 0 }}
            transition={transition}
          />
        ))}
      </svg>
    </div>
  );
}
